export const tabHeader2 = [
  { key: "1", label: "Регіон" },
  { key: "2", label: "100% Потреба" },
  { key: "3", label: "100% потреба профінансовано" },
  { key: "4", label: "Залишки" },
  { key: "5", label: "Початкова забезпеченість" },
  { key: "6", label: "Забезпеченість після розподілу" },
  { key: "7", label: "Розподілена кількість" },
  { key: "8", label: "" },
];

export const mnnTabHeader2 = [
  { key: "1", label: "МНН" },
  { key: "2", label: "МНН ID" },
  { key: "3", label: "Залишок у запасі" },
  { key: "4", label: "Ціна" },
  { key: "5", label: "Кратність" },
  { key: "6", label: "Перевірено" },
  { key: "7", label: "" },
];

export const attachmentsTabHeader2 = [
  { key: "1", label: "Тип" },
  { key: "2", label: "Файл" },
  { key: "3", label: "Номер" },
  { key: "4", label: "Дата" },
  { key: "5", label: "Завантаження здійснив" },
  { key: "6", label: "" },
];

export const datesTabHeader2 = [
  { key: "1", label: "МНН" },
  { key: "2", label: "МНН ID" },
  { key: "3", label: "Контрольна дата" },
];
